export const ACCESS = 'access';
export const READ_WEP = 'read_wep';
export const EDIT_WEP = 'edit';
export const EDIT_ACTUAL = 'edit_actual';
export const READ_COMPLETED = 'read_completed';
export const ASSIGN_WEP = 'assign_wep';
export const REOPEN_WEP = 'reopen_wep';
